import React, { useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Languages, Loader2 } from "lucide-react";

// Shows text; if written in another language, offers an auto-translation while keeping the original.
export default function TranslateText({ text, originalLanguage, className = "", testId = "translate-btn" }) {
  const { lang, t } = useLang();
  const [translated, setTranslated] = useState(null);
  const [showT, setShowT] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);

  const canTranslate = text && originalLanguage && originalLanguage !== lang && originalLanguage !== "other";

  const toggle = async () => {
    if (showT) { setShowT(false); return; }
    if (translated) { setShowT(true); return; }
    setBusy(true); setErr(false);
    try {
      const { data } = await api.post("/community/translate", { text, target: lang });
      setTranslated(data.translation);
      setShowT(true);
    } catch { setErr(true); } finally { setBusy(false); }
  };

  return (
    <div className={className}>
      <p className="text-stone-300/90 whitespace-pre-line break-words" data-testid="post-content-text">
        {showT && translated ? translated : text}
      </p>
      {canTranslate && (
        <div className="mt-2 flex items-center gap-2">
          <button data-testid={testId} onClick={toggle} disabled={busy}
            className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-amber-500 hover:text-amber-400 disabled:opacity-50">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Languages className="w-3.5 h-3.5" />}
            {busy ? t("com_translating") : showT ? t("com_show_original") : t("com_show_translation")}
          </button>
          {showT && translated && <span className="text-[10px] font-mono uppercase tracking-wider text-stone-500 italic">{t("com_auto_translated")}</span>}
          {err && <span className="text-xs text-red-400">{t("com_translate_unavailable")}</span>}
        </div>
      )}
    </div>
  );
}
